import { TransferActions } from "manifest-components/src/classes/transferInstruction";
import { TransferStatusTypes } from "manifest-components/src/classes/transfer";
import { DevelopmentEnvironmentState } from "./developmentEnvironmentState";

export enum Actions {
  LOAD_STATE = "LOAD_STATE",
  SET_HIDE_MENU = "SET_HIDE_MENU",
  SET_SHOW_MENU = "SET_SHOW_MENU",
  SET_SHOW_ONE_TIME_CODE = "SET_SHOW_ONE_TIME_CODE",
  SET_SHOW_RESTART_TRANSFER = "SET_SHOW_RESTART_TRANSFER",
  SET_TRANSFER_INPUT_REASON_OVERRIDE = "SET_TRANSFER_INPUT_REASON_OVERRIDE",
  SET_SHOW_LOCATION_STATE = "SET_SHOW_LOCATION_STATE",
  SHOW_VERSION_NOTIFIER = "SHOW_VERSION_NOTIFIER",
  SET_TRANSFER_STATUS_OVERRIDE = "SET_TRANSFER_STATUS_OVERRIDE",
}

export type Action =
  | { type: Actions.SET_SHOW_LOCATION_STATE; payload: boolean }
  | { type: Actions.SET_SHOW_MENU; payload: boolean }
  | { type: Actions.SET_HIDE_MENU; payload: boolean }
  | { type: Actions.SET_SHOW_ONE_TIME_CODE; payload: boolean }
  | { type: Actions.SET_SHOW_RESTART_TRANSFER; payload: boolean }
  | { type: Actions.SHOW_VERSION_NOTIFIER }
  | { type: Actions.LOAD_STATE; payload: typeof DevelopmentEnvironmentState }
  | { type: Actions.SET_TRANSFER_INPUT_REASON_OVERRIDE; payload: TransferActions | "" }
  | { type: Actions.SET_TRANSFER_STATUS_OVERRIDE; payload: TransferStatusTypes | "" };
